<template>
  <div>
    <HTMLHeader></HTMLHeader>
    <div class="wrapper">
      <HTMLMenu></HTMLMenu>

      <div class="content">
        <div class="container">
          <div class="floating-buttons">
            <router-link class="fl-button" :to="{ path: '/controller/edit/' }"><i class="fa fa-plus"></i></router-link>
          </div>
          <h1>Kontrollerek</h1>

          <div class="row">
            <div class="col-xs-12">
              <h2>Kereső</h2>
            </div>
            <div class="col-xs-2">
              <inputbox id="name" @keydownEnter="searchClick" label="Megnevezés" id="name" name="name" v-model="search.name"></inputbox>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="building_id" label="Épület" name="building_id" v-model="search.building_id" :options="buildings" :change="buildingChange"></comboboxV2>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="building_level_id" label="Épület szint" name="building_level_id" :options="building_levels" v-model="search.building_level_id"></comboboxv2>
            </div>
            <div class="col-xs-2">
              <comboboxV2 id="controller_type_id" label="Kontroller típus" name="controller_type_id" :options="controller_types" v-model="search.controller_type_id"></comboboxv2>
            </div>
            <div class="col-xs-3">
              <button class="button with-icon" style="margin-top: 24px" type="button" v-on:click="searchClick"><i class="fa fa-search"></i>Keresés</button>
            </div>
          </div>

          <div v-if="controllers.length > 0" class="table-with-title">
            <h2>Kontrollerek</h2>
            <table class="list">
              <thead>
                <tr>
                  <th>Megnevezés</th>
                  <th>Alias</th>
                  <th>Épület</th>
                  <th>Épület szint</th>
                  <th>Koordináta</th>
                  <th>Serial szám</th>
                  <th>Típus</th>
                  <th>Connection</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="controller in controllers">
                  <td>{{ controller.name }}</td>
                  <td>{{ controller.alias }}</td>
                  <td>{{ controller.building }}</td>
                  <td>{{ controller.building_level }}</td>
                  <td>{{ controller.x_coord }}, {{ controller.y_coord }}</td>
                  <td>{{ controller.serial_number }}</td>
                  <td>{{ controller.controller_type }}</td>
                  <td>{{ controller.connection }}</td>
                  <td class="buttons">
                    <router-link class="small-button" :to="{ path: '/controller/edit/', query: { controllerID: controller.element_id }}"><i class="fa fa-pencil-alt"></i></router-link>
                    <a class="small-button" href="javascript:void(0)" v-on:click="del(controller.element_id)"><i class="fa fa-trash-alt"></i></a>

                    <ul class="small-buttons">
                      <li>
                        <a class="small-button with-menu" href="javascript:void(0)"><i class="fa fa-cog"></i></a>
                        <div class="small-button-menu">
                          <div class="head">Opciók</div>
                          <ul>
                            <!--<li><a href="javascript:void(0)" v-on:click="controllerOperation(controller.element_id, 'KONTROLLER_ELINDIT', 'Elindítja a kontrollert?')"><i class="fa fa-check icon"></i>Elindít</a></li>
                            <li><a href="javascript:void(0)" v-on:click="controllerOperation(controller.element_id, 'KONTROLLER_LEALLIT', 'Leállítja a kontrollert?')"><i class="fa fa-ban icon"></i>Leállít</a></li>-->
                            <li><a href="javascript:void(0)" v-on:click="controllerOperation(controller.element_id, 'KONTROLLER_RESET', 'Reseteli a kontrollert?')"><i class="fa fa-sync icon"></i>Reset</a></li>
                            <!--<li><a href="javascript:void(0)" v-on:click="controllerDevicesReset(controller.element_id, 'KONTROLLER_ESZKOZ_RESET', 'Reseteli a kontrollerre csatlakoztatott eszközöket?')"><i class="fa fa-sync icon"></i>Eszköz reset</a></li>-->
                            <!--<li><a href="javascript:void(0)" v-on:click="controllerDevicesReset(controller.element_id, controller.serial_number, 'soft')"><i class="fa fa-sync icon"></i>Soft eszköz reset</a></li>-->
                            <li><a href="javascript:void(0)" v-on:click="controllerDevicesReset(controller.element_id, controller.serial_number, 'hard')"><i class="fa fa-sync icon"></i>Eszköz reset (hard)</a></li>
                            <li><a href="javascript:void(0)" v-on:click="controllerUploadCards(controller.element_id, controller.serial_number)"><i class="fa fa-upload icon"></i>Kártyák feltöltése</a></li>
                            <li><a href="javascript:void(0)" v-on:click="controllerDeleteCards(controller.element_id, controller.serial_number)"><i class="fa fa-eraser icon"></i>Kártyák törlése a kontrollerről</a></li>
                          </ul>
                        </div>
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <pagination v-if="controllers.length > 0" showcombo="1" :limit="search.limit" :amount="search.amount" v-on:pageChanged="pageChanged" v-model="search.page"></pagination>
        </div>
      </div>

    </div>
    <HTMLFooter></HTMLFooter>
  </div>
</template>
<script>
import Vue from 'vue';

export default {
  components: {
  },

  data: function() {
    return {
      search: {
        name: '',
        building_id: 0,
        building_level_id: 0,
        controller_type_id: 0,
        page: 1,
        limit: 100,
        amount: 0
      },

      controllers: [],
      buildings: [],
      building_levels: [{
        label: '- összes -',
        value: 0
      }],
      controller_types: []
    }
  },

  watch: {
    '$route': 'routerChange'
  },

  created: function() {
    this.routerChange();
  },

  mounted: function() {
    this.getBuildings();

    if (this.search.building_id != 0) {
      this.getBuildingLevels();
    }

    this.getControllerTypes();
  },

  methods: {
    controllerOperation: function(id, alias, title) {
      var _this = this;

      swal({
        title: title,
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('operation/add/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              alias: alias,
              params: JSON.stringify({id: id})
            },
            success: function(response) {
              swal('Siker', 'A művelet kiadva.', 'success');
            }
          });

          _this.$root.ajax('log/write/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              log_type_alias: alias,
              params: JSON.stringify({id: id})
            },
            success: function(response) {
            }
          });
        }
      });
    },

    /*controllerDevicesReset: function(id, alias, title) {
      var _this = this;

      swal({
        title: title,
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('controller/device_reset/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              alias: alias,
              params: JSON.stringify({id: id})
            },
            success: function(response) {
              swal('Siker', 'A művelet kiadva.', 'success');
            }
          });

          _this.$root.ajax('log/write/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              log_type_alias: alias,
              params: JSON.stringify({id: id})
            },
            success: function(response) {
            }
          });
        }
      });
    },*/

    del: function(id) {
      var _this = this;

      swal({
        title: 'Törli az olvasót?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('controller/delete/' + _this.$root.user.apikey + '/' + id, {
            success: function(response) {
              _this.getItems();
            }
          });
        }
      });
    },

    buildingChange: function(v) {
      var _this = this;

      if (_this.search.building_id == 0) {
        _this.building_levels = [{
          label: '- összes -',
          value: 0
        }];
        _this.search.building_level_id = 0;
        return;
      }

      this.getBuildingLevels();
      this.search.building_level_id = 0;
    },

    getControllerTypes: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('controller_types/' + _this.$root.user.apikey + '/1', {
          success: function(response) {
            var tmp = [{
              label: '- összes -',
              value: 0
            }];

            response.types.map(function(type) {
              tmp.push({
                label: type.name,
                value: type.id
              })
            });
            _this.controller_types = tmp;
          }
        });
      });
    },

    getBuildings: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('buildings/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {},
          success: function(response) {
            var tmp = [{
              label: '- összes -',
              value: 0
            }];

            response.buildings.map(function(building) {
              tmp.push({
                label: building.name,
                value: building.id
              })
            });
            _this.buildings = tmp;
          }
        });
      });
    },

    getBuildingLevels: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('building_levels/' + _this.$root.user.apikey + '/1', {
          method: 'POST',
          data: {
            building_id: _this.search.building_id
          },
          success: function(response) {
            var tmp = [{
              label: '- összes -',
              value: 0
            }];

            response.levels.map(function(level) {
              tmp.push({
                label: level.name,
                value: level.id
              })
            });
            _this.building_levels = tmp;
          }
        });
      });
    },

    routerChange: function() {
      if (Object.keys(this.$route.query).length != 0) {
        this.search = $.extend(this.search, JSON.parse(JSON.stringify(this.$route.query)));
      }

      this.getItems();
    },

    searchClick: function() {
      this.search.page = 1;
      this.$router.push({path: '/controllers', query: this.search});
    },

    pageChanged: function(val) {
      this.search.page = val;
      this.$router.push({path: '/controllers', query: this.search});
    },

    getItems: function() {
      var _this = this;

      this.$root.checkRootUserHasSet(function() {
        _this.$root.ajax('controllers/' + _this.$root.user.apikey, {
          data: _this.search,
          method: 'POST',
          success: function(response) {
            _this.controllers = response.controllers;
            _this.search.amount = response.amount;
          }
        });
      });
    },

    controllerDevicesReset(element_id, serial_number, type) {
      var _this = this;

      swal({
        title: 'Újraindítja a '+serial_number+' szériaszámú kontrolleren lévő eszközöket '+type+'?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('log/write/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              log_type_alias: 'KONTROLLER_ESZKOZ_RESET_'+type.toUpperCase(),
              params: JSON.stringify({
                element_id: element_id,
                serial_number: serial_number
              })
            },
            success: function(response) {
              swal('Siker', 'A művelet kiadva.', 'success');
            }
          });
        }
      });
    },

    controllerUploadCards(element_id, serial_number) {
      var _this = this;

      swal({
        title: 'Feltölti a kártyákat a kontrollerre?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('log/write/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              log_type_alias: 'KARTYA_FELTOLTES_KONTROLLERRE',
              params: JSON.stringify({
                element_id: element_id,
                serial_number: serial_number
              })
            },
            success: function(response) {
              swal('Siker', 'A művelet kiadva.', 'success');
            }
          });
        }
      });
    },

    controllerDeleteCards(element_id, serial_number) {
      var _this = this;

      swal({
        title: 'Törli az összes kártyát a '+serial_number+' szériaszámú kontrollerről?',
        text: '',
        icon: 'warning',
        buttons:
        {
          confirm: {
            text: "Igen",
            value: true,
            closeModal: true
          },
          cancel: {
            text: "Nem",
            value: false,
            visible: true,
            closeModal: true
          }
        }
      }).then(function (result) {
        if (result) {
          _this.$root.ajax('log/write/' + _this.$root.user.apikey, {
            method: 'POST',
            data: {
              log_type_alias: 'ALL_CARD_DELETE_FROM_CONTROLLER',
              params: JSON.stringify({
                element_id: element_id,
                serial_number: serial_number
              })
            },
            success: function(response) {
              swal('Siker', 'A művelet kiadva.', 'success');
            }
          });
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// controllers.vue?2c787fad